import { environment } from '../../../../environments/environment';

export function gtagFactory() {
    if (!environment.googleTagId) {
        return null;
    }

    if ((window as any).gtag) {
        return (window as any).gtag;
    }

    const script = document.createElement('script');

    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.googleTagId;
    script.type = 'text/javascript';
    script.async = true;

    document.head.appendChild(script);

    (window as any).dataLayer = (window as any).dataLayer || [];

    function gtag(...args) {
        (window as any).dataLayer.push(arguments);
    }

    gtag('js', new Date());

    gtag('config', environment.googleTagId, {});

    return (window as any).gtag = gtag;
}

